import { ApiServerEntityIDType } from '@common/types';
import React from 'react';
import { useClientOwnCatalogItemViews } from './useClientOwnCatalogItemViews';

export const useCatalogItemIsViewed = (catalogItemId: ApiServerEntityIDType): boolean => {
  const ownViews = useClientOwnCatalogItemViews();

  return React.useMemo(() => ownViews.some((r) => r.catalogItemId === catalogItemId), [catalogItemId, ownViews]);
};
